import { FC, ReactNode } from 'react';
import { SendFormsContext } from './context';
import { useSendFormsProviders, type UseSendFormsProvidersProps } from './hooks/useSendFormsProviders';

type SendFormsMainProps = UseSendFormsProvidersProps & {
  children: ReactNode;
};

const SendFormsMain: FC<SendFormsMainProps> = ({ children, ...props }) => {
  const value = useSendFormsProviders(props);

  return <SendFormsContext.Provider value={value}>{children}</SendFormsContext.Provider>;
};

export default SendFormsMain;
